import * as React from 'react';
import { useEffect } from 'react';
import { StoreContext } from './StoreContext';
export var StoreContextProvider = function (_a) {
    var Store = _a.value, children = _a.children;
    useEffect(function () {
        Store.setup();
        return function () {
            Store.teardown();
        };
    }, [Store]);
    return (React.createElement(StoreContext.Provider, { value: Store }, children));
};
//# sourceMappingURL=StoreContextProvider.js.map